// Module
var code = "<div class=\"crm-calendar-simple\"> <uib-datepicker ng-model=\"vm.preselectDate\" ng-change=\"vm.onChange({ data: vm.preselectDate })\" datepicker-options=\"vm.datePickerOptions\"></uib-datepicker> </div> ";
// Exports
module.exports = code;